import type { WorkItemTraceability } from "@zworks/console-contracts";

/** CSV export functionality */
export function exportTraceabilityToCSV(data: WorkItemTraceability[]) {
  const headers = [
    "Work Item Key",
    "Work Item Title",
    "Tests Count",
    "Passed Count",
    "Failed Count",
    "Blocked Count",
    "Coverage Status",
  ];

  const csvRows = data.map((item) => [
    item.workItemKey,
    item.workItemTitle,
    item.testCount.toString(),
    item.passedCount.toString(),
    item.failedCount.toString(),
    item.blockedCount.toString(),
    item.coverageStatus,
  ]);

  const csvContent = [
    headers.join(","),
    ...csvRows.map((row) =>
      row
        .map((cell) => {
          if (
            typeof cell === "string" &&
            (cell.includes(",") || cell.includes('"') || cell.includes("\n"))
          ) {
            return `"${cell.replace(/"/g, '""')}"`;
          }
          return cell;
        })
        .join(","),
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `work-items-traceability-${new Date().toISOString().split("T")[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
